import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { authFetch } from '../utils/api'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('jwtToken'))
  const username = ref(localStorage.getItem('username'))
  const role = ref(localStorage.getItem('role') || 'viewer')

  const isAuthenticated = computed(() => !!token.value)
  const isAdmin = computed(() => role.value === 'admin')
  const isEditor = computed(() => role.value === 'editor')
  const canEdit = computed(() => role.value === 'admin' || role.value === 'editor')

  const login = (newToken: string, newUsername: string, newRole: string) => {
    token.value = newToken
    username.value = newUsername
    role.value = newRole
    localStorage.setItem('jwtToken', newToken)
    localStorage.setItem('username', newUsername)
    localStorage.setItem('role', newRole)
  }

  const logout = () => {
    token.value = null
    username.value = null
    role.value = 'viewer'
    localStorage.removeItem('jwtToken')
    localStorage.removeItem('username')
    localStorage.removeItem('role')
  }

  // Sync role from server on init — localStorage may be stale or missing
  const syncRole = async () => {
    if (!token.value) return
    try {
      const res = await authFetch('/api/auth/user')
      if (res.ok) {
        const data = await res.json()
        if (data.user?.role) {
          role.value = data.user.role
          localStorage.setItem('role', data.user.role)
        }
        if (data.user?.username) {
          username.value = data.user.username
          localStorage.setItem('username', data.user.username)
        }
      }
    } catch {
      // silent — authFetch handles 401 by clearing session and redirecting
    }
  }

  return { token, username, role, isAuthenticated, isAdmin, isEditor, canEdit, login, logout, syncRole }
})
